import Vue from 'vue'
import {
  SIDEBAR_TYPE,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE
} from '@/store/mutation-types'
const app = {
  state: {
    sidebar: true,
    device: 'desktop',
    theme: 'light',
    layout: 'sidemenu',
    collapsed: false,
    bodyWidth: document.body.clientWidth,
    bodyHeight: document.body.clientHeight,
    firstLogin: false,
    microAppLoading: false,
    microApp: null
  },
  mutations: {
    SET_FIRST_LOGIN: (state, status) => {
      state.firstLogin = status
    },
    SET_SIDEBAR_TYPE: (state, type) => {
      state.sidebar = type
      Vue.ls.set(SIDEBAR_TYPE, type)
    },
    CLOSE_SIDEBAR: (state) => {
      Vue.ls.set(SIDEBAR_TYPE, true)
      state.sidebar = false
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    TOGGLE_COLLAPSED: (state, collapsed) => {
      state.collapsed = collapsed
    },
    BODY_WIDTH: (state, width) => {
      state.bodyWidth = width
    },
    BODY_HEIGHT: (state, height) => {
      state.bodyHeight = height
    },
    TOGGLE_THEME: (state, theme) => {
      // setStore('_DEFAULT_THEME', theme)
      Vue.ls.set(DEFAULT_THEME, theme)
      state.theme = theme
    },
    TOGGLE_LAYOUT_MODE: (state, layout) => {
      Vue.ls.set(DEFAULT_LAYOUT_MODE, layout)
      state.layout = layout
    },
    SET_MICRO_APP_LOADING: (state, microAppLoading) => {
      state.microAppLoading = microAppLoading
    }
  },
  actions: {
    setSidebar ({ commit }, type) {
      commit('SET_SIDEBAR_TYPE', type)
    },
    CloseSidebar ({ commit }) {
      commit('CLOSE_SIDEBAR')
    },
    ToggleDevice ({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    ToggleTheme ({ commit }, theme) {
      commit('TOGGLE_THEME', theme)
    },
    ToggleLayoutMode ({ commit }, mode) {
      commit('TOGGLE_LAYOUT_MODE', mode)
    }
  }
}

export default app
